import type { Theme } from '@mui/material/styles';
//
import {
  CheckboxIcon,
  CheckboxCheckedIcon,
  CheckboxIndeterminateIcon,
} from './CustomIcons';
import type { Components } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Checkbox(
  theme: Theme
): Pick<Components, 'MuiCheckbox'> {
  return {
    MuiCheckbox: {
      defaultProps: {
        icon: <CheckboxIcon color="primary" />,
        checkedIcon: <CheckboxCheckedIcon />,
        indeterminateIcon: <CheckboxIndeterminateIcon />,
        disableFocusRipple: true,
        disableRipple: true,
        disableTouchRipple: true,
      },

      styleOverrides: {
        root: {
          padding: theme.spacing(1),
          '&.Mui-checked.Mui-disabled, &.Mui-disabled': {
            color: theme.palette.action.disabled,
          },
          // The unchecked icon has its own primary color, override it too.
          '&.Mui-disabled .MuiSvgIcon-root': {
            color: theme.palette.action.disabled,
          },
          '& .MuiSvgIcon-fontSizeMedium': {
            width: 24,
            height: 24,
          },
          '& .MuiSvgIcon-fontSizeSmall': {
            width: 20,
            height: 20,
          },
          svg: {
            fontSize: 24,
            '&[font-size=small]': {
              fontSize: 20,
            },
          },
        },
      },
    },
  };
}
